(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9653,1674],{

/***/ 976783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/collections/[collectionId]",
      function () {
        return __webpack_require__(84914);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(755847);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(331399);
/* harmony import */ var _containers_Collections__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(676671);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268037);
/* harmony import */ var src_containers_404Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(692687);









var CollectionsSpecificToId = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSetSSRStore */ .Vn)(props.ssrStore);
    var storeInfo = (0,_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSSRSelector */ .kF)(function(state) {
        return state.storeReducer.store;
    });
    if (props === null || props === void 0 ? void 0 : props.notFound) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_containers_404Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        store: storeInfo,
        title: (props === null || props === void 0 ? void 0 : (ref = props.advCustomSeoDetails) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.value) ? props === null || props === void 0 ? void 0 : (ref2 = props.advCustomSeoDetails) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.title) === null || ref3 === void 0 ? void 0 : ref3.value : "".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref4 = storeInfo.store_info) === null || ref4 === void 0 ? void 0 : ref4.name).concat((storeInfo === null || storeInfo === void 0 ? void 0 : (ref5 = storeInfo.address) === null || ref5 === void 0 ? void 0 : ref5.visibility) === 1 && (storeInfo === null || storeInfo === void 0 ? void 0 : (ref6 = storeInfo.address) === null || ref6 === void 0 ? void 0 : ref6.city) ? ",".concat(storeInfo === null || storeInfo === void 0 ? void 0 : (ref7 = storeInfo.address) === null || ref7 === void 0 ? void 0 : ref7.city) : "", " - Order Online"),
        OGTitle: (props === null || props === void 0 ? void 0 : (ref8 = props.advCustomSeoDetails) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.og_title) === null || ref9 === void 0 ? void 0 : ref9.value) || null,
        OGDescription: (props === null || props === void 0 ? void 0 : (ref10 = props.advCustomSeoDetails) === null || ref10 === void 0 ? void 0 : ref10.og_description) || null,
        Icon: storeInfo === null || storeInfo === void 0 ? void 0 : (ref11 = storeInfo.store_info) === null || ref11 === void 0 ? void 0 : ref11.logo_image,
        metaDescription: (props === null || props === void 0 ? void 0 : (ref12 = props.advCustomSeoDetails) === null || ref12 === void 0 ? void 0 : ref12.description) ? props === null || props === void 0 ? void 0 : (ref13 = props.advCustomSeoDetails) === null || ref13 === void 0 ? void 0 : ref13.description : storeInfo && (0,_utils_getMetaDescription__WEBPACK_IMPORTED_MODULE_8__/* .getMetaDescription */ .w)(storeInfo),
        OGImage: storeInfo === null || storeInfo === void 0 ? void 0 : (ref14 = storeInfo.store_info) === null || ref14 === void 0 ? void 0 : ref14.logo_image,
        isCustomDomain: props.isCustomDomain,
        canonicalTagUrl: props === null || props === void 0 ? void 0 : (ref15 = props.canonicalUrlData) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.item_group_details) === null || ref16 === void 0 ? void 0 : ref16.link
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_Collections__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props))
    }));
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (CollectionsSpecificToId);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6956,3662,4434,8388,1562,5843,6379,4814,7856,6576,9228,4429,6246,8487,4914,8738,1033,1399,3978,2682,3973,526,8557,7909,1788,4640,6307,2265,5684,9142,5973,9774,2888,179], function() { return __webpack_exec__(976783); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);